<template>
  <div>
    <login-top middleTop="登录">
      <div
        slot="right"
        style="font-size: 14px;"
        @click="$router.push('/register')"
      >
        切换到注册
      </div>
    </login-top>
    <login-form
      style="margin: 15px 0"
      label="账号"
      placeholder="请填入账号"
      rule="^.{5,16}$"
      @inputChange="value => (model.username = value)"
    />
    <login-form
      label="密码"
      placeholder="请填入密码"
      type="password"
      rule="^.{5,16}$"
      @inputChange="value => (model.password = value)"
    />
    <login-btn btn_text="登录" @registerSubmit="registerSubmit"></login-btn>
    <input
      type="button"
      value="暂不登录"
      class="btn"
      @click="$router.push('/')"
    />
  </div>
</template>

<script>
import LoginTop from "@/components/common/LoginTop.vue";
import LoginForm from "@/components/common/LoginForm.vue";
import LoginBtn from "@/components/common/LoginBtn.vue";
export default {
  data() {
    return {
      model: {
        username: "",
        password: ""
      }
    };
  },
  components: {
    LoginTop,
    LoginForm,
    LoginBtn
  },
  methods: {
    async registerSubmit() {
      let rulg = /^.{3,16}$/;
      if (rulg.test(this.model.username) && rulg.test(this.model.passwor)) {
        const res = await this.$http.post("/home/api/login", this.model);
        this.$msg.fail(res.data.msg);

        if (res.data.code == 301 || res.data.code == 302) {
          return;
        }
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("id", res.data.id);
        setTimeout(() => {
          this.$router.push("./");
        }, 1000);
      } else {
        this.$msg.fail("格式不正确，请重新输入");
      }
    }
  }
};
</script>

<style scoped lang="scss">
.btn {
  display: block;
  margin: 0 auto;
  border: 0;
  color: #999;
  font-size: 14px;
  background: none;
}
</style>
